<svg
  width="33"
  height="34"
  viewBox="0 0 33 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_5331)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.21841 6.26262C4.70924 6.25023 5.27988 6.25 6 6.25H27C27.7201 6.25 28.2908 6.25023 28.7816 6.26262C29.0543 6.2695 29.2757 6.27968 29.4574 6.29256C29.4703 6.47425 29.4805 6.6957 29.4874 6.96841C29.4998 7.45924 29.5 8.02988 29.5 8.75V25.25C29.5 25.9701 29.4998 26.5408 29.4874 27.0316C29.4805 27.3043 29.4703 27.5257 29.4574 27.7074C29.2757 27.7203 29.0543 27.7305 28.7816 27.7374C28.2908 27.7498 27.7201 27.75 27 27.75H6C5.27988 27.75 4.70924 27.7498 4.21841 27.7374C3.9457 27.7305 3.72425 27.7203 3.54256 27.7074C3.52968 27.5257 3.5195 27.3043 3.51262 27.0316C3.50023 26.5408 3.5 25.9701 3.5 25.25V8.75C3.5 8.02988 3.50023 7.45924 3.51262 6.96841C3.5195 6.6957 3.52968 6.47425 3.54256 6.29256C3.72425 6.27968 3.9457 6.2695 4.21841 6.26262ZM0 8.75C0 5.92157 0 4.50736 0.87868 3.62868C1.75736 2.75 3.17157 2.75 6 2.75H27C29.8284 2.75 31.2426 2.75 32.1213 3.62868C33 4.50736 33 5.92157 33 8.75V25.25C33 28.0784 33 29.4926 32.1213 30.3713C31.2426 31.25 29.8284 31.25 27 31.25H6C3.17157 31.25 1.75736 31.25 0.87868 30.3713C0 29.4926 0 28.0784 0 25.25V8.75Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_5331">
      <rect width="33" height="33" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
